import { create } from 'zustand';

const cartKey = process.env.REACT_APP_LOCAL_STORAGE_CART;

export const cartStore = create((set) => ({
  cart: [],
  showCart: false,

  toggleCart: () => set((state) => ({ showCart: !state.showCart })),
  openCart: () => set({ showCart: true }),
  closeCart: () => set({ showCart: false }),

  addToCart: (item) =>
    set((state) => {
      const filteredCart = state.cart.filter((i) => i.type !== item.type);
      const updated = [...filteredCart, item];
      localStorage.setItem(cartKey, JSON.stringify(updated));
      return { cart: updated };
    }),

  removeFromCart: (type) =>
    set((state) => {
      const updated = state.cart.filter((i) => i.type !== type);
      localStorage.setItem(cartKey, JSON.stringify(updated));
      return { cart: updated };
    }),

  updateQuantity: (id, delta) =>
    set((state) => {
      const updated = state.cart.map((item) =>
        item.id === id
          ? {
              ...item,
              quantity: Math.max(1, item.quantity + delta), // mínimo 1
            }
          : item
      );
      localStorage.setItem(cartKey, JSON.stringify(updated));
      return { cart: updated };
    }),
}));
